<template>
  <div
    :class="`input-wrapper ${disabled && 'cursor-pointer'}`"
    @click="handleClick()"
  >
    <div class="gray700">{{ title }}</div>
    <div :class="`input-icons ${inputClass}`">
      <i class="fas fa-search" v-if="!iconDisable"></i>
      <input
        type="text"
        :class="`input-no-border ${disabled && 'cursor-pointer'}`"
        :placeholder="placeholder"
        :value="model"
        @input="$emit('input', $event.target.value)"
        :disabled="disabled"
      />
    </div>
  </div>
</template>
<script>
export default {
  props: [
    'title',
    'placeholder',
    'model',
    'inputClass',
    'disabled',
    'onClick',
    'iconDisable',
  ],
  methods: {
    handleClick() {
      if (this.onClick) {
        this.onClick()
      } else {
        // do nothing
      }
    },
  },
}
</script>
